/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import {
  Box,
  Card,
  CardMedia,
  Container,
  Toolbar,
  Typography,
  makeStyles,
} from "@mui/material";

import { MobileTopBar } from "../components/mobileTopBar";
import {
  TERTIARY_COLOR,
  SECONDARY_COLOR,
  PRIMARY_COLOR,
} from "../consts/colors";
import { ProductCard } from "../components/productCard";
import { PRODUCTS } from "../consts/products";

export const Catalog = () => {
  return (
    <Container sx={{ backgroundColor: TERTIARY_COLOR, padding: 0 }}>
      <MobileTopBar />
      {PRODUCTS.map((product, index) => (
        <ProductCard
          key={index}
          id={product.id}
          name={product.name}
          price={product.price}
          size={product.size}
          imageUrl={product.imageUrl}
          specifications={product.specifications}
        />
      ))}
    </Container>
  );
};
